import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class app_custom_ds_get_license_plate_info_for_alter_pallet_hold_by_licensePlateIdService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { licensePlateId?: number }): 
  Promise<{ result: { Id?: number, Archived?: boolean, LookupCode?: string, LicensePlateContents?: { LotId?: number, Lot?: { Id?: number, LookupCode?: string, Material?: { Id?: number, LookupCode?: string, Project?: { LookupCode?: string, Name?: string } } } }[] } }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      licensePlateId?: number    }) {
      return false;
    }
}
